import React, { useState, useEffect, useRef } from "react";
import "../Styles/VDCGridLeftLayout.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCommentDots } from "@fortawesome/free-solid-svg-icons";
import fetchConversationData from "../Utils/UserVideoLoadChatHistory";
import "../../../Styles/common-styles.css";
import RenderGroupConversationContent from "../Utils/RenderGroupConversationContent";
import "../../Styles/uac-common-styles.css";
import kleidologo from "../../../../../assets/images/Kleido.png"

const UMGridLeftLayout = ({ userId, mode }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [profileImage] = useState("/assets/Profile/profile-biker.jpeg");
  const [conversations, setConversations] = useState({});
  const [submode, setSubmode] = useState("groupchat");
  const [chatInput, setChatInput] = useState("");   // For chat box
  const [chatHistory, setChatHistory] = useState([]);
  const chatHistoryRef = useRef(null);

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    setSubmode(value.trim() !== "" ? "searchkey" : "groupchat");
  };

  const handleMemberChatClick = () => {
    setSubmode("memberchat");
  };

  useEffect(() => {
    const fetchData = async () => {
      const data = await fetchConversationData();
      if (typeof data !== "object") {
        throw new Error("Invalid JSON structure");
      }
      setConversations(data);
      // Flatten initial chat history from all months/messages (for demo).
      if (data?.conversations) {
        const flatMessages = [];
        data.conversations.forEach((conv) => {
          conv.allmessages?.forEach((entry) => {
            entry.messages?.forEach((msg) => {
              flatMessages.push({ ...msg, date: entry.date, month: conv.month });
            });
          });
        });
        setChatHistory(flatMessages);
      }
    };
    fetchData();
  }, []);

  // Handle sending new chat message
  const handleSendChat = () => {
    if (chatInput.trim()) {
      const newMsg = {
        id: Date.now(),
        sender: userId,
        content: chatInput,
        date: new Date().toLocaleDateString(),
        time: new Date().toLocaleTimeString(),
      };
      setChatHistory((prev) => [...prev, newMsg]);
      setChatInput("");
      // Auto-scroll to newest
      setTimeout(() => {
        if (chatHistoryRef.current) {
          chatHistoryRef.current.scrollTop = chatHistoryRef.current.scrollHeight;
        }
      }, 100);
    }
  };

  return (
    <div style={{
      display: "flex",
      flexDirection: "column",
      height: "auto", 
      width: "100%",
      position: "relative",
      background: "black",
      borderRadius: 20,
      padding: 0,
    }}>
      {/* Top Section: Profile & Search */}
      <div className="uac-profile-section" style={{ flex: "0 0 auto", paddingBottom: 2 }}>
        <img src={kleidologo} alt="Profile" className="uac-profile-pic" />
        <h2 className="subgroup-header" style={{ fontSize: 21, color: "#fff", marginLeft: 20, marginTop: 30 }}>
          Chat History
        </h2>
      </div>

      <div className="uac-search-bar" style={{ width: "100%", height: 60 }}>
        <input
          className="uac-search-input-container"
          placeholder="Search chat history..."
          value={searchTerm}
          onChange={handleSearchChange}
        />
        <button
          className="Member-Chat-Click-container"
          onClick={handleMemberChatClick}
          style={{ background: "gray", marginTop: 20 }}
        >
          +
        </button>
      </div>

      {/* Chat History Container Scrollable */}
      <div 
        ref={chatHistoryRef}
        className="chat-history-scroll"
        style={{
          // flex: "1 1 auto",            // fill available vertical space
          overflowY: "auto",           // enable vertical scroll
          background: "#191919",
          borderRadius: 10,
          margin: "13px 8px",
          padding: "3px 12px",
          boxShadow: "0 1px 2px rgba(0,0,0,0.22)",
          minHeight: 0,                // important to allow shrinking inside flex parent
          height: 480
        }}
      >
        {chatHistory.length === 0 && <div style={{ color: "#aaa", margin: 18 }}>No messages yet.</div>}
        <ul className="message-list">
          {chatHistory.map((msg) => (
            <li key={msg.id} className="message-item" style={{marginBottom:6, color:"#eee"}}>
              <span style={{fontWeight:"bold", color:"#29e6e6"}}>{msg.sender}</span>: 
              <span style={{marginLeft:8}}>{msg.content}</span>
              <span style={{marginLeft:12, fontSize:12, color:"#888"}}>
                {msg.date} {msg.time}
              </span>
            </li>
          ))}
        </ul>
      </div>

      {/* Chat Box at Bottom */}
      <div className="chat-input-bar" style={{
        flex: "0 0 auto",
        width: "98%",
        padding: "12px",
        display: "flex",
        alignItems: "center",
        gap: "10px",
        background: "#2b2d34",
        margin: "0 8px",
        borderRadius: "10px",
        boxShadow: "0px 0px 2px #222"
      }}>
        <input
          type="text"
          value={chatInput}
          onChange={e => setChatInput(e.target.value)}
          placeholder="Type your message..."
          style={{
            flex: 1,
            padding: "10px",
            borderRadius: "8px",
            border: "1px solid #444",
            background: "#111",
            color: "#eee",
            fontSize: 15,
          }}
          onKeyUp={e => { if (e.key === "Enter") handleSendChat(); }}
        />
        <button
          className="send-chat-button"
          onClick={handleSendChat}
          style={{
            background: "#29e6e6",
            color: "#232323",
            borderRadius: "8px",
            padding: "0 18px",
            fontWeight: "bold",
            fontSize: 15,
            border: "none",
            cursor: "pointer",
            minWidth: "60px",
          }}
        >
          Send
        </button>
      </div>

      {/* Fixed Post Button (Sticky at bottom right of sidebar) */}
      <button
        className="post-button"
        style={{
          position: "fixed",
          right: "30px",
          bottom: "30px",
          background: "#f97a11",
          color: "#fff",
          borderRadius: "50%",
          width: "53px",
          height: "53px",
          boxShadow: "0 2px 8px rgba(0,0,0,0.18)",
          border: "none",
          fontSize: 25,
          fontWeight: "bold",
          zIndex: 1001,
          cursor: "pointer"
        }}
        onClick={() => alert("Post action triggered!")}
        title="Post"
      >
        +
      </button>
    </div>
  );
};

export default UMGridLeftLayout;
